import { t } from '@lingui/core/macro';
import { NoddiButton } from 'noddi-ui-web';
import { formatDateTimeRange } from 'noddi-util';
import { useStationaryBookingActions } from '../../../stores/StationaryBookingStore';

type Props = {
  selectedTimeWindow?: { startsAt: string; endsAt: string };
};

/**
 * Confirmed stationary window + remove (clears store; stale-hold release cancels the bay).
 * Renders bare, not in a card: it sits inside FixedBottomBarContainer, which is
 * already a NoddiBasicCard.
 */
export const SelectedStationaryBookingTime = ({ selectedTimeWindow }: Props) => {
  const { setReservation } = useStationaryBookingActions();

  if (!selectedTimeWindow) {
    return null;
  }

  const timeWindowText = formatDateTimeRange(selectedTimeWindow.startsAt, selectedTimeWindow.endsAt);

  return (
    <NoddiButton
      variant='outline'
      startIcon='X'
      aria-label={`${t`Remove`}: ${timeWindowText}`}
      onClick={() => setReservation(null)}
    >
      {timeWindowText}
    </NoddiButton>
  );
};
